import LandingModel from '../models/landing.model';

let storeContent = utils.generateStore({
	LandingModel,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async submitQuote(ctx) {},
	},
};
